export default "__VITE_ASSET__mXwlJkFp__"